import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import { FormGroup, Input, Label } from 'reactstrap';
import ModalHeader from '../../components/ModalHeader';
import CenterSpinner from '../../components/CenterSpinner';
import { getNoteDate } from '../../utils/Util';
import ApproveLeaveDetails from '../../components/ApproveLeaveDetails';
import LeaveHistoryDetails from '../../components/LeaveHistoryDetails';
import { LeaveDetails } from '../../utils/Types';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  approveOrRejectLeave,
  attendanceSelector,
  fetchLeaveDetails,
} from '../../features/attendanceSlice';
import { LEAVE_PAGE_TYPE } from '../../utils/Constant';
import {
  getLeaveApproveParams,
  onApproveRejectSuccess,
} from '../attendance/ViewAttendeesPageHelper';

interface ILeaveModalProps {
  isOpen: boolean;
  selectedDetails?: any;
  toggleApproveModal: () => void;
  type: string | null;
  fetchLeaves: () => void;
}

const LeaveModal: React.FunctionComponent<ILeaveModalProps> = ({
  isOpen,
  selectedDetails,
  toggleApproveModal,
  type,
}: ILeaveModalProps) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [comment, setComment] = useState<string>('');
  const leaveDetails: LeaveDetails | null =
    useAppSelector(attendanceSelector).leaveDetails;

  const handleApproveRejectLeave = (type: string) => {
    const data = getLeaveApproveParams(type, comment, leaveDetails);
    setShowLoader(true);
    try {
      dispatch(approveOrRejectLeave(data))
        ?.then((fulfilled: any) => {
          onApproveRejectSuccess(fulfilled, toggleApproveModal, setShowLoader);
        })
        ?.catch(() => {
          setShowLoader(false);
        });
    } catch (er) {}
  };

  const getLeaveDetails = () => {
    setShowLoader(true);
    dispatch(
      fetchLeaveDetails({ leaveRequestId: selectedDetails?.leaveRequestId })
    );
  };
  useEffect(() => {
    setShowLoader(false);
  }, [leaveDetails]);
  useEffect(() => {
    getLeaveDetails();
  }, []);

  const getCommentAndAction = (showComment: boolean) => (
    <>
      <div className="bg-comment my-4 mx-4 p-4  rounded">
        {showComment && (
          <div className="mb-3">
            <FormGroup>
              <Label for="comment" className="model-comment-title">
                Comments &#40;<span className="text-danger ">* </span>
                {''}
                Mandatory for Rejection&#41;
              </Label>
              <Input
                id="comment"
                name="comment"
                type="textarea"
                maxLength={250}
                value={comment}
                placeholder="Please Comment"
                className="rounded border model-comment-area"
                onChange={(event) => setComment(event.target.value)}
              />
            </FormGroup>
          </div>
        )}

        <div className="bg-white rounded border px-4 pt-3 pb-3">
          <Label for="comment" className="model-comment-title">
            Log Details
          </Label>
          <div className="modal-log-div">
            <ul className="li-item model-log-value">
              {leaveDetails?.notes?.length &&
                leaveDetails?.notes.map((noteItem: any) => (
                  <li
                    className="mt-1"
                    key={`noteItem-li-${noteItem?.notesId ?? noteItem?.notesid}`}
                  >
                    {getNoteDate(noteItem)}
                    {noteItem.notesDescription}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>

      {showComment && (
        <div className="mt-5 d-flex justify-content-center">
          <Button
            variant="primary"
            className="m-1 cl-btn-primary"
            onClick={() => {
              handleApproveRejectLeave('approve');
            }}
          >
            Approve
          </Button>
          <Button
            variant="outline-primary"
            className="m-1 cl-btn-outline-primary"
            onClick={() => {
              handleApproveRejectLeave('reject');
            }}
          >
            Reject
          </Button>
        </div>
      )}
    </>
  );

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleApproveModal();
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader
          photoUrl={leaveDetails?.photo}
          toggle={() => {
            toggleApproveModal();
          }}
        />
        {type === LEAVE_PAGE_TYPE.APPROVE_LEAVE ? (
          <>
            <ApproveLeaveDetails
              user={selectedDetails}
              leaveDetails={leaveDetails}
            />
            {getCommentAndAction(true)}
          </>
        ) : (
          <>
            <LeaveHistoryDetails leaveDetails={leaveDetails} />
            {getCommentAndAction(false)}
            <div className="mt-5 d-flex justify-content-center">
              <Button
                variant="primary"
                className="m-1 cl-btn-primary"
                onClick={toggleApproveModal}
              >
                Close
              </Button>
            </div>
          </>
        )}
        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default LeaveModal;
